import { Component, Input, TemplateRef, input, ChangeDetectionStrategy } from '@angular/core';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgTemplateOutlet, NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'customer-component-tooltip',
  templateUrl: './component-tooltip.component.html',
  styleUrls: ['./component-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CdkOverlayOrigin, NgTemplateOutlet, MatIcon, NgStyle, CdkConnectedOverlay]
})
export class ComponentTooltipComponent {
  readonly icon = input<string>(undefined);
  @Input() triggerComponent: TemplateRef<unknown>;
  readonly disable = input(false);
  readonly iconSize = input('15px');
  public isVisible: boolean;

  public displayOverlay(): void {
    if (!this.disable()) {
      this.isVisible = true;
    }
  }

  public hideOverlay(): void {
    this.isVisible = false;
  }
}
